import {
  Currencies,
  Notifications,
  SFXS
} from '@orbital/games-frontend-library'
import floorFigure from '../../../configs/floorFigure'

export default function HandleOperation(
  stake: string,
  operation: string,
  prec: number,
  minbet: number,
  maxbet: number,
  handleStake: (s: string) => void,
  handleNotification: any,
  currency: string,
) {
  let newStake = +stake

  const min = Number(minbet)
  const max = Number(maxbet)
  switch (operation) {
    case "1/2":
      newStake <= min ? "" : (newStake /= 2)
      break
    case "2x":
      newStake > max ? (newStake = max) : (newStake *= 2)
      break
    default:
      break
  }
  if (newStake > max) {
    newStake = Number(max.toFixed(prec))
    handleNotification(
      Notifications.maxStake +
      max.toFixed(prec) +
      Currencies[currency],
    )
  }
  if (newStake <= min) {
    newStake = Number(min.toFixed(prec))
    handleNotification(
      Notifications.minStake + min.toFixed(prec) + Currencies[currency],
    )
  }
  return handleStake(newStake.toFixed(prec))
}